import keys from "locale/keys";
import { useTranslation } from "react-i18next";

import CouponPlaceholder from "../../../assets/icons/CouponPlaceholder.svg";
import { ShoppingCardProps } from "./interface";
import {
  BrandImage,
  BrandName,
  CardContent,
  CashBackBadge,
  CashBackBadgeText,
  CashBackLabel,
  CashBackRow,
  CashBackValue,
  GetOfferButton,
  ShoppingCard,
} from "./styled.components";

const ShoppingCardItem = ({ item }: ShoppingCardProps) => {
  const { t } = useTranslation();
  const { name, trackingUrl, imageURL, cashbackOffer } = item;

  const onGetOffer = () => {
    window.open(trackingUrl, "_blank", "noopener,noreferrer");
  };

  return (
    <ShoppingCard>
      <CardContent>
        <BrandImage
          src={imageURL}
          alt={name}
          loading="lazy"
          onError={(e) => {
            e.currentTarget.src = CouponPlaceholder;
          }}
        />
        <CashBackBadge>
          <CashBackBadgeText>{cashbackOffer}</CashBackBadgeText>
        </CashBackBadge>
        <BrandName noWrap>{name}</BrandName>
        <CashBackRow>
          <CashBackLabel>{t(keys.cash_back)}:</CashBackLabel>
          <CashBackValue>{cashbackOffer}</CashBackValue>
        </CashBackRow>
        <GetOfferButton variant="contained" fullWidth onClick={onGetOffer}>
          {t(keys.get_offer)}
        </GetOfferButton>
      </CardContent>
    </ShoppingCard>
  );
};

export default ShoppingCardItem;
